import React from 'react';
import styled from 'styled-components';
import { Empty, Typography } from 'antd';
import { useTranslation } from '../../../../../i18n/useTranslation';
import { EMPTY_MESSAGES } from '../../constants';

const StyledEmpty = styled(Empty)`
    padding: 40px;
    .ant-empty-footer {
        .ant-btn:not(:last-child) {
            margin-right: 8px;
        }
    }
`;

const EmptyDescription = styled.div`
    > * {
        max-width: 70ch;
        display: block;
        margin-right: auto;
        margin-left: auto;
    }
`;

type Props = {
    tab: string;
    children?: React.ReactNode;
};

/**
 * Gets the display name for the relation, capitalizing the first letter
 */
const getCapitalizedRelationName = (relationName: string) => {
    return relationName.charAt(0).toUpperCase() + relationName.slice(1);
};

export const EmptyTab = ({ tab, children }: Props) => {
    const { t } = useTranslation();

    // Check if we have a predefined message for this tab
    const predefinedMessage = EMPTY_MESSAGES[tab];

    // For custom relations (no predefined message), use dynamic translated messages
    const title = predefinedMessage
        ? t(predefinedMessage.title)
        : t('Has no {{relationName}} relations', { relationName: getCapitalizedRelationName(tab) });

    const description = predefinedMessage
        ? t(predefinedMessage.description)
        : t('Entities can have "{{relationName}}" relations to represent a "{{relationName}}" style relationship.', {
              relationName: getCapitalizedRelationName(tab),
          });

    return (
        <StyledEmpty
            description={
                <EmptyDescription>
                    <Typography.Title level={4}>{title}</Typography.Title>
                    <Typography.Text type="secondary">{description}</Typography.Text>
                </EmptyDescription>
            }
        >
            {children}
        </StyledEmpty>
    );
};
